export const CURRENCIES = [
    { code: "USD", symbol: "$", label: "US Dollar (USD)" },
    { code: "INR", symbol: "₹", label: "Indian Rupee (INR)" },
];

export const DEFAULT_CURRENCY = "USD";

export const getCurrencySymbol = (code) => CURRENCIES.find((c) => c.code === code)?.symbol || "$";

export const getCurrencyLabel = (code) => CURRENCIES.find((c) => c.code === code)?.label || code;

export const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const num = Number(String(value).replace(/,/g, ""));
    if (isNaN(num)) return value;
    return num.toLocaleString("en-US");
}

export const formatCurrencyDecimal = (value, code = DEFAULT_CURRENCY) => {
    const symbol = getCurrencySymbol(code);
    const num = Number(String(value ?? 0).replace(/,/g, ""));
    const amount = isNaN(num) ? "0.00" : num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${symbol}${amount}`;
}